<template>
  <div class="agus__m">
    <div class="agus__m-grid">
      <component
        :is="item.link ? 'a' : 'div'"
        class="agus__m-grid_item"
        v-for="(item, index) in items"
        :key="index"
        @click="!item.link && openModal(index)"
        v-bind="item.link ? { href: item.link, target: '_blank' } : {}"
      >
        <div class="agus__m-grid_item-text">
          <div class="agus__m-grid_item-title">{{ item.title }}</div>
          <div class="agus__m-grid_item-descr">{{ item.description }}</div>
        </div>
        <div class="agus__m-grid_item-svg">
          <svg
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="0.0454102" width="28" height="28" rx="14" fill="#830051" />
            <path
              d="M14.5 9.04541L19.5 14.0454L14.5 19.0454"
              stroke="#E6CCDC"
              stroke-linecap="square"
            />
            <path
              d="M18.5 14.0454L8.5 14.0454"
              stroke="#E6CCDC"
              stroke-linecap="square"
            />
          </svg>
        </div>
      </component>
    </div>
    <div
      v-if="selectedItemIndex !== null"
      class="modal-overlay"
      @click.self="closeModal"
    >
      <div class="modal">
        <div class="modal-header">
          <div class="modal-header_title">
            {{ modalData[selectedItemIndex].title }}
          </div>
          <div class="close" @click="closeModal">
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 7L25 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path
                d="M25 7L7 25"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
            </svg>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-block">
            <div
              class="modal-block-text"
              v-for="(block, index) in modalData[selectedItemIndex].content"
              :key="index"
            >
              <div class="modal-block-text__inner" v-html="block.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PNGModalBlock",
  data() {
    return {
      items: [
        {
          title: "Плазмотерапия",
        },
        {
          title: "Патогенетическая комплемент-блокирующая терапия",
          link: "https://az-most.ru/therapeutic-areas/rare-diseases/paroksizmalnaya-nochnaya-gemoglobinuriya"
        },
        {
          title: "Сопутствующая терапия ",
          description: "в зависимости от конкретных клинических проявлений",
        },
        {
          title: "Хирургическое лечение терминальной почечной недостаточности",
        },
      ],
      modalData: [
        {
          title: "Плазмотерапия",
          content: [
            {
              text: "Рекомендуется проведение плазмотерапии в виде плазмообмена в качестве терапии первой линии всем пациентам с предполагаемым диагнозом аГУС или рецидивом заболевания, если диагноз был установлен ранее, в ожидании результатов обследования на SТЕС-ГУС и определения АDАМТS13 для снижения выраженности жизнеугрожающих клинических проявлений болезни.<br><br> Пациентам с предполагаемым диагнозом аГУС рекомендуется проводить плазмотерапию в виде трансфузий СЗП только в случае невозможности немедленного начала ПО или его недоступности. <br><br> <strong>Критериями эффективности плазмотерапии служат нормализация числа тромбоцитов и прекращение гемолиза, о чем свидетельствует нормализация ЛДГ. Продолжительность лечения СЗП не определена, однако показанием к прекращению плазмотерапии является нормальное количество тромбоцитов и уровень ЛДГ в течение 2-х дней подряд.</strong> <br><br> Пациентам с аутоиммунным аГУС, определенным на основании обнаружения анти-СРН-антител, рекомендуется проводить плазмообмены в комбинации с индукционной терапией глюкокортикоидами и/или иммунодепрессантами для снижения риска неблагоприятных клинических событий. <br><br> Лечение аутоиммунного аГУС требует сочетания плазмотерапии с глюкокортикоидами и противоопухолевыми препаратами.",
            },
          ],
        },
        {
          title: "Патогенетическая комплемент-блокирующая терапия",
          content: [
            {
              text: "Гемолиз при ПНГ слабо выражен и носит постоянный характер, независимо от времени суток.<br><br>Исторически термин «ночной» связан с тем, что в учебниках приводились примеры пациентов с темным цветом мочи после пробуждения.",
            },
          ],
        },
        {
          title: "Сопутствующая терапия",
          content: [
            {
              text: "По показаниям при аГУС могут применяться дополнительные методы лечения, например: <br><br> <div class='mb-4 numeric-block numeric-block_light'><div class='numeric-block__num numeric-block__num-standart numeric-block__num-light'>1.</div><div>При развитии кровотечения или при использовании инвазивных вмешательств с высоким риском кровоточивости показана трансфузии тромбоконцентрата. Процедура связана с риском усугубления тромбоцитопении и генерализации микротромбообразования<sup>22</sup>.</div></div><div class='mb-4 numeric-block numeric-block_light'><div class='numeric-block__num numeric-block__num-standart numeric-block__num-light'>2.</div><div>С целью коррекции тяжелой МАГА (гемоглобин менее 75 г/л) проводится трансфузия эритроцитарной массы.</div></div><div class='numeric-block numeric-block_light'><div class='numeric-block__num numeric-block__num-standart numeric-block__num-light'>3.</div><div>При наличии артериальной гипертензии, вызванной хронической болезнью почек, или при остром повреждении почек важно лечить патологию, придерживаясь соответствующих клинических рекомендаций.</div></div><br>Также важно отслеживать и, по возможности, вовремя устранять триггеры, которые могут ухудшить течение болезни.",
            },
          ],
        },
        {
          title: "Хирургическое лечение",
          content: [
            {
              text: "Степень риска рецидива (высокий, средний или низкий) после пересадки почки у пациентов с аГУС должна определяться как на основании результата генетического тестирования, так и с учётом клинического течения заболевания, частоты рецидивов ТМА и семейного анамнеза. Хотя в целом риск определяется преимущественно типом мутаций, частично он зависит и от других перитрансплантационных факторов:<br><br><ul class='mb-6 custom-list_purple' style='padding-left: 20px;'><li>тяжелого ишемически-реперфузионного повреждения трансплантата;</li><li>высоких концентраций в крови реципиента ингибиторов кальциневрина;</li><li>острого отторжения трансплантата, особенно гуморального;</li><li>вирусных инфекций<sup>23</sup>.</li></ul>Перед трансплантацией рекомендовано профилактическое лечение комплемент-блокирующим препаратом – по сравнению со стартом терапии после операции оно ассоциировано с улучшением функции ренального трансплантата и снижением риска потребности в гемодиализе<sup>24</sup>.",
            },
          ],
        },
      ],
      selectedItemIndex: null,
    };
  },
  methods: {
    openModal(index) {
      this.selectedItemIndex = index;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.selectedItemIndex = null;
      document.body.style.overflow = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.agus__m {
  &-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      grid-gap: 16px;
    }
    &_item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 24px;
      border: 1px solid #f36c3e;
      transition: all 0.2s linear;
      &:hover {
        background-color: #f36c3e1a;
      }
      @media screen and (max-width: 1199px) {
        gap: 0;
        min-height: 175px;
      }
      @media screen and (max-width: 767px) {
        flex-direction: row;
        justify-content: space-between;
        min-height: auto;
        gap: 16px;
      }
      &-text {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      &-title {
        font-family: "Roboto", sans-serif;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        @media screen and (max-width: 767px) {
          font-size: 16px;
          line-height: 22px;
        }
      }
      &-descr {
        font-family: "Roboto", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
      }
      &-svg {
        margin-top: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}

.modal {
  background: #f8f8f8;
  border-radius: 8px;
  position: relative;
  width: 100%;
  max-width: 800px;
  overflow-y: auto;
  @media screen and (max-width: 1199px) {
    width: 80%;
  }
  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000;
    overflow: hidden;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f36c3e;
    padding: 24px;
    border-radius: 8px 8px 0 0;
    &_title {
      font-family: "Roboto Slab", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #ffffff;
    }
  }
  .close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
  &-content {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 80vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-block {
    display: flex;
    flex-direction: row;
    gap: 16px;
    &-text {
      display: flex;
      flex-direction: column;
      gap: 16px;
      &__inner {
        font-family: "Roboto", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
}
</style>
